import { useEffect } from "react";
import FormDropDown from "../../../forms/DropDownList/FormDropDown";

const LivePollSelector = (props) => {
    // Build our drop down options from props.customisationData.setup.pollData.polls[i].title
    const pollListData = [];
    const pollTypes = [];
    const pollsData = props.customisationData?.setup?.pollData?.polls;
    const pollListSignature = (pollsData || []).map((poll) => `${poll?.title || ''}:${poll?.type || ''}`).join('|');
    const getPollState = (pollIndex) => {
        const featureVars = props.passedInPreviewData ? props.passedInPreviewData : props.featureVars;
        const pollTitle = pollsData?.[pollIndex]?.title;
        return featureVars?.pollControl?.pollsState?.find((state) => state.pollTitle === pollTitle) || null;
    };
    const syncSelectedPollControls = (pollIndex) => {
        const pollState = getPollState(pollIndex);
        const answerState = pollState?.answerState || [];
        const pollHasVotes = answerState.some((answer) => answer.votePercentage > 0);
        const correctAnswer = answerState.findIndex((answer) => answer.correct);

        props.changeValFunc('pollControl', 'pollRunning', pollState?.pollRunning === true, false, false, false);
        props.changeValFunc('pollControl', 'pollVisible', pollState?.pollVisible === true, false, false, false);
        props.changeValFunc('pollControl', 'pollHasVotes', pollHasVotes, false, false, false);
        props.changeValFunc('pollControl', 'correctAnswer', correctAnswer, false, false, false);
        props.changeValFunc('pollControl', 'selectedPollType', pollTypes[pollIndex], false, false, false);
    };
    if (!pollsData) {
        pollListData.push({
            id: 0,
            label: "No Polls Available",
            value: 0,
            val: 0
        });
    } else {
        for (let i = 0; i < pollsData.length; i++) {
            const poll = pollsData[i];
            if (!poll) continue;
            pollListData.push({
                id: i,
                label: poll.title || `Poll ${i + 1}`,
                value: i,
                val: i
            });
            pollTypes[i] = poll.type;
        }
    }

    useEffect(() => {
        console.log('--- LivePollSelector, useEffect: ', props.value, pollListData, props.featureVars, props.passedInPreviewData);
        if (props.value < 0 || props.value >= pollListData.length) {
            props.setFunc(0);
            return;
        }
        syncSelectedPollControls(props.value);
        
        // Does the selected poll have any votes?
        const featureVars = props.passedInPreviewData ? props.passedInPreviewData : props.featureVars;
        console.log('--- LivePollSelector, used featureVars: ', featureVars, props.customisationData?.setup?.pollData?.polls?.[props.value]);
        let pollData = null; // featureVars?.pollControl?.pollsState?.[props.value]; // props.customisationData?.setup?.pollData?.polls?.[props.value];
        if (featureVars?.pollControl?.pollsState) {
            for (let i = 0; i < featureVars.pollControl.pollsState.length; i++) {
                if (featureVars.pollControl.pollsState[i].pollTitle === props.customisationData?.setup?.pollData?.polls?.[props.value]?.title) {
                    pollData = featureVars.pollControl.pollsState[i];
                    break;
                }
            }
        }
        let pollHasVotes = false;
        let correctAnswer = -1;
        if (pollData && pollData.answerState && pollData.answerState.length > 0) {
            for (let i = 0; i < pollData.answerState.length; i++) {
                if (pollData.answerState[i].votePercentage > 0) {
                    pollHasVotes = true;
                }
                if (pollData.answerState[i].correct) {
                    correctAnswer = i;
                }
            }
        }

        console.log('--- LivePollSelector, pollData: ', pollData, pollHasVotes, correctAnswer);

        props.changeValFunc('pollControl', 'pollHasVotes', pollHasVotes, false, false, false);
        props.changeValFunc('pollControl', 'correctAnswer', correctAnswer, true, false, true);

    }, [props.value, pollListSignature]);

    // onMount - make sure we have these values!
    useEffect(() => {
        if (props.featureVars.pollControl.pollRunning !== true && props.featureVars.pollControl.pollRunning !== false) {
            props.changeValFunc('pollControl', 'pollRunning', false, false, false, false);
        }
        if (props.featureVars.pollControl.pollVisible !== true && props.featureVars.pollControl.pollVisible !== false) {
            props.changeValFunc('pollControl', 'pollVisible', false, false, false, false);
        }
        // Ensure we have a valid poll index
        let correctPollIndex = props.value;
        if (isNaN(correctPollIndex) || correctPollIndex < 0 || correctPollIndex >= pollListData.length) {
            correctPollIndex = 0;
        }
        if (correctPollIndex !== props.value) {
            props.setFunc(correctPollIndex);
        }

        // Does the selected poll have any votes?
        // const pollData = featureVars?.pollControl?.pollsState?.[correctPollIndex]; // props.customisationData?.setup?.pollData?.polls?.[props.value];
        // const pollData = props.customisationData?.setup?.pollData?.polls?.[correctPollIndex];
        const pollData = getPollState(correctPollIndex);
        let pollHasVotes = false;
        let correctAnswer = -1;
        if (pollData && pollData.answerState && pollData.answerState.length > 0) {
            for (let i = 0; i < pollData.answerState.length; i++) {
                if (pollData.answerState[i].votePercentage > 0) {
                    pollHasVotes = true;
                }
                if (pollData.answerState[i].correct) {
                    correctAnswer = i;
                }
            }
        }

        // These false, false, false flags are to prevent the changeValFunc from reporting a change and also rebuilding state data
        // we're doing this because we only need to report changes and update state once all these values have changed.
        // The final true, false, false flag tells the dashboard to report the changes, but still hold off on rebuilding state data
        // this is because the state data will get rebuilt anyway after the data is reported - if we use default behaviour we get some thrashing
        // of the state and our button flickers between states, this ensures we only update the state once.

        console.log('--- LivePollSelector, pollData: ', pollData, pollHasVotes, correctAnswer);

        props.changeValFunc('pollControl', 'pollHasVotes', pollHasVotes, false, false, false);
        props.changeValFunc('pollControl', 'correctAnswer', correctAnswer, false, false, false);
        props.changeValFunc('pollControl', 'selectedPollType', pollTypes[correctPollIndex], true, false, true);
    }, []);

    const featureVars = props.passedInPreviewData ? props.passedInPreviewData : props.featureVars;
    const forceHideAllPolls = (event) => {
        props.sendFeatureCommandFunc(event, 'END_POLL', props.featureId, '');
    };

    return (
        <>
            <button className="standard-button live-but-orange" onClick={(event) => props.sendFeatureCommandFunc(event, 'editLivePolls', props.featureId, '')} style={{ minWidth: '100%' }}>
                Create/Edit Poll
            </button>
            <div className="live-poll-existing-polls-title form-field-content var-label">Existing Polls</div>
            <FormDropDown
                label={props.label}
                items={pollListData}
                value={props.value}
                selectFunc={
                    (e, id, item) => {
                        syncSelectedPollControls(item.index);
                        props.setFunc(item.index);
                    }
                }
                currentIndex={props.value}
                showErrors={false}
                enabled={pollListData.length > 1 && !featureVars?.pollControl?.pollVisible}
            />
            <button className="standard-button live-but-red" onClick={forceHideAllPolls} style={{ minWidth: '100%' }}>
                Hide All Polls
            </button>
        </>
    )
};

export default LivePollSelector;
